import { render, staticRenderFns } from "./MealPortionsTable.vue?vue&type=template&id=3f1cb880&scoped=true&"
import script from "./MealPortionsTable.vue?vue&type=script&lang=js&"
export * from "./MealPortionsTable.vue?vue&type=script&lang=js&"
import style0 from "./MealPortionsTable.vue?vue&type=style&index=0&id=3f1cb880&scoped=true&lang=scss&"
import style1 from "./MealPortionsTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1cb880",
  null
  
)

export default component.exports